import React from 'react';
import { useInAppMessage, useResponsive } from '../../../../hooks';
import { ExportBtnExcel } from "../../../molecules";
import useDataGrid from '../../data-grid/use-data-grid';

interface Props {
    className?: string;
    disabled?: boolean;
    iconOnly?: boolean;
    enableMobile?: boolean;
}
export default function ExportToExcel({ className, iconOnly, disabled, enableMobile }: Props) {

    const grid = useDataGrid();
    const message = useInAppMessage();
    const count = grid.tableData.length;
    const res = useResponsive();
    const isDisabled = (disabled) ? true : (grid.isLoading) ? true : false;
    const isIconOnly = (iconOnly) ? true : (!res.lgDown && enableMobile) ? true : false;
    const onExport = () => {
        const resolveExportMSG = () => message.createSuccess(`Exported ${count} ${(count === 1) ? 'row' : 'rows'}!`, { dismiss: 5000 });
        message.createLoading(`Exporting ${count} ${(count === 1) ? 'row' : 'rows'}...`);
        setTimeout(() => {
            resolveExportMSG();
        }, 2000);
    }

    return (
        <>
            <ExportBtnExcel
                className={className}
                small
                data={grid.tableData}
                fields={grid.columnFields}
                iconOnly={isIconOnly}
                disabled={isDisabled}
                onExport={onExport}
            />
        </>
    )
}